<div class="tabs">
  <button *ngFor="let option of options"
          type="button"
          class="tab"
          [class.active]="option.value === activeValue"
          (click)="select(option.value)"
          [attr.aria-pressed]="option.value === activeValue"
          [attr.data-testid]="'tab-bar-btn-' + option.value">
    <ng-container *ngTemplateOutlet="optionTemplate || defaultTemplate; context: { $implicit: option }"></ng-container>
  </button>
</div>

<ng-template #defaultTemplate
             let-option>
  {{ option.label }}
</ng-template>